import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { useAuth } from '@/hooks/useAuth';
import { ArrowLeft, Save, Image, MapPin } from 'lucide-react';
import LoginPrompt from '@/components/shared/LoginPrompt';

const DiaryEditor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [location, setLocation] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id) {
      // TODO: Load existing diary
      setTitle('加载中...');
    }
  }, [id]);

  const handleSave = async () => {
    if (!title.trim()) return alert('请输入标题');
    setSaving(true);
    try {
      // TODO: Save diary logic
      await new Promise(r => setTimeout(r, 1000));
      navigate('/diaries');
    } catch (err) {
      alert('保存失败');
    } finally {
      setSaving(false);
    }
  };

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(180deg, rgba(22,37,68,0.82) 0%, rgba(30,56,96,0.75) 40%, rgba(22,37,68,0.82) 100%)' }}>
        <div className="w-10 h-10 border-2 border-t-transparent rounded-full animate-spin" style={{ borderColor: 'rgba(106,179,214,0.3)', borderTopColor: 'var(--bloom)' }} />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen relative" style={{ background: 'linear-gradient(180deg, rgba(22,37,68,0.82) 0%, rgba(30,56,96,0.75) 40%, rgba(22,37,68,0.82) 100%)' }}>
        <Navbar />
        <div className="pt-28 pb-20 relative z-10">
          <LoginPrompt title="写日记" description="登录后记录你的旅行故事和美好回忆" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen relative" style={{ background: 'linear-gradient(180deg, rgba(22,37,68,0.85) 0%, rgba(30,56,96,0.78) 40%, rgba(22,37,68,0.85) 100%)' }}>
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 md:px-6 pt-24 pb-12 relative z-10">
        <div className="flex items-center justify-between mb-6">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-cb hover:text-white transition">
            <ArrowLeft className="w-5 h-5" /> 返回
          </button>
          <button onClick={handleSave} disabled={saving} className="frost px-4 py-2 rounded-xl flex items-center gap-2 text-sm font-medium hover:bg-[rgba(106,179,214,0.1)] transition">
            <Save className="w-4 h-4" /> {saving ? '保存中...' : '保存'}
          </button>
        </div>

        <input
          type="text"
          value={title}
          onChange={e => setTitle(e.target.value)}
          placeholder="输入日记标题..."
          className="w-full text-2xl font-bold bg-transparent border-none outline-none cb placeholder-cd mb-4"
        />

        <div className="flex items-center gap-4 mb-6">
          <div className="flex items-center gap-2 text-sm cd">
            <Image className="w-4 h-4" /> 添加图片
          </div>
          <div className="flex items-center gap-2 text-sm cd">
            <MapPin className="w-4 h-4" />
            <input
              type="text"
              value={location}
              onChange={e => setLocation(e.target.value)}
              placeholder="添加地点..."
              className="bg-transparent border-none outline-none cd w-32"
            />
          </div>
        </div>

        <textarea
          value={content}
          onChange={e => setContent(e.target.value)}
          placeholder="开始记录你的旅行故事..."
          className="w-full min-h-[400px] bg-transparent border-none outline-none text-base cb leading-relaxed resize-none"
          style={{ background: 'rgba(30,56,96,0.2)', borderRadius: '12px', padding: '16px' }}
        />
      </div>
    </div>
  );
};

export default DiaryEditor;
